/** What the Approvals and audit tabs share, and nothing else (ADR-0212, P10).
 *
 * The audit ledger, Activity and Assurance each answer a role that may not read them, or an Auditor
 * whose engagement cannot be applied to a chain, with **a sentence rather than a failed read** - a
 * "try again" on a refusal that repeats identically is a control that predictably fails (UX-04). The
 * sentence used to be a paragraph of ninety words. On a table page a state is one short sentence, so
 * the lead is the sentence and the reason (the server's own remedy where it sent one) is one control
 * away, in a drawer that names what it is. Nothing is deleted: the reason is the same string, moved.
 */

import { useState } from "react";
import type { ReactNode } from "react";

import { Drawer } from "../components/ui";
import styles from "./Screen.module.css";

export function WhyNote({
  testId,
  lead,
  why,
  whyTitle,
  whyLabel = "Why",
  asked,
}: {
  testId: string;
  /** The one sentence on the page. */
  lead: ReactNode;
  /** The reason, in the drawer. */
  why: ReactNode;
  whyTitle: string;
  whyLabel?: string;
  /** `refused` when the server was asked and said no; `not-asked` when `/auth/me` said so up front
   * and the request was never made. A test and the browser gate read it. */
  asked?: "refused" | "not-asked";
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <p className={styles.note} data-testid={testId} data-asked={asked}>
        <strong>{lead}</strong>{" "}
        <button type="button" className={styles.fixLink} aria-haspopup="dialog" onClick={() => setOpen(true)}>
          {whyLabel}
        </button>
      </p>
      <Drawer open={open} onClose={() => setOpen(false)} title={whyTitle} width="sm" testId={`${testId}-drawer`}>
        <p data-testid={`${testId}-why`}>{why}</p>
      </Drawer>
    </>
  );
}
